var _path, _path2, _linearGradient, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M22 12l-1.828-1.828A4 4 0 0017.343 9H5.5c-1.38 0-2.48 1.12-2.48 2.5L3 36.5A2.5 2.5 0 005.5 39h37c1.38 0 2.48-1.12 2.48-2.5l.02-22a2.5 2.5 0 00-2.5-2.5H22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD75E",
    d: "M22 12l-1.975 1.975A3.5 3.5 0 0117.55 15H3v21.5A2.5 2.5 0 005.5 39h37c1.38 0 2.48-1.12 2.48-2.5l.02-22a2.5 2.5 0 00-2.5-2.5H22z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    y1: 12,
    x2: 24,
    y2: 39
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ffd75e",
    stopOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M22 12l-1.828 1.828A4 4 0 0117.343 15H3v21.5A2.5 2.5 0 005.5 39h37c1.38 0 2.48-1.12 2.48-2.5l.02-22a2.5 2.5 0 00-2.5-2.5H22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFF",
    d: "M22 12l-1.828 1.828A4 4 0 0117.343 15H3v1h14.636a4.5 4.5 0 003.182-1.318L23.5 12H22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E67628",
    d: "M5 38a2.971 2.971 0 01-1.84-.647A2.493 2.493 0 005.5 39h37c1.08 0 1.991-.689 2.34-1.647-.509.399-1.142.647-1.84.647H5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.47d21f0c5f9382fe80de2ae7728ab530.svg";
export { ForwardRef as ReactComponent };